/**
 * "Shortcuts" (saved Task Library filter views) — backend-persisted per
 * account via backend/src/routes/shortcuts (AuthenticateChatUser, scoped to
 * the session's own ChatUser id server-side). Replaces an earlier
 * per-device/localStorage design per CU-123yxuav7zz follow-up.
 */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { request, ReqMethods } from "../lib/apiClient";

const { GET, POST, PUT, DELETE } = ReqMethods;

export const shortcutsKeys = {
  all: ["shortcuts"],
};

export function useShortcutsList() {
  return useQuery({
    queryKey: shortcutsKeys.all,
    queryFn: async () => {
      const res = await request(GET, "/shortcuts");
      return Array.isArray(res?.data) ? res.data : [];
    },
  });
}

export function useSaveShortcut() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ name, search }) => request(POST, "/shortcuts", { payload: { name, search } }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: shortcutsKeys.all }),
  });
}

export function useRenameShortcut() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, name }) => request(PUT, `/shortcuts/${id}`, { payload: { name } }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: shortcutsKeys.all }),
  });
}

export function useRemoveShortcut() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => request(DELETE, `/shortcuts/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: shortcutsKeys.all }),
  });
}
